/* Bridgewater Direct header: Shop all products mega menu, Help & advice menu,
   phone/tablet drawer and cart button. Department shortcuts are plain links.
   Markup: sections/bd-header.liquid, snippets/bd-mega-content.liquid.
   Without this script the header still works as plain links (html lacks .bd-js). */
(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 1100px)';
  var HOVER_DELAY = 220; /* ms the pointer rests on a department before it switches */

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function focusables(root) {
    return qsa(
      root,
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  /* One department switcher (desktop mega menu or drawer). Same markup, two modes:
     desktop keeps every panel laid out (stable height) and shows the chosen one;
     drawer shows the list, or one department with a Back button. */
  function DeptMenu(root, mode, signal, onChange) {
    var buttons = qsa(root, '[data-bd-dept-btn]');
    var panels = qsa(root, '[data-bd-dept-panel]');
    var nav = qs(root, '.bd-mm__nav');
    var current = null;
    var hoverTimer = null;

    function panelFor(key) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-bd-dept-panel') === key) return panels[i];
      }
      return null;
    }
    function buttonFor(key) {
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].getAttribute('data-bd-dept-btn') === key) return buttons[i];
      }
      return null;
    }

    function select(key) {
      if (!panelFor(key)) key = buttons.length ? buttons[0].getAttribute('data-bd-dept-btn') : null;
      current = key;
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-bd-dept-btn') === key;
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-bd-dept-panel') === key;
        p.classList.toggle('is-active', on);
        if (mode === 'desktop') {
          p.hidden = false;
          if (on) p.removeAttribute('inert');
          else p.setAttribute('inert', '');
        } else {
          p.hidden = !on;
        }
      });
      if (mode === 'drawer' && nav) nav.hidden = !!key;
      if (onChange) onChange(key);
    }

    function showList() {
      current = null;
      buttons.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('is-active');
        p.hidden = true;
      });
      if (nav) nav.hidden = false;
      if (onChange) onChange(null);
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener(
        'click',
        function () {
          clearTimeout(hoverTimer);
          var key = btn.getAttribute('data-bd-dept-btn');
          select(key);
          if (mode === 'drawer') {
            var back = qs(panelFor(key), '[data-bd-mm-back]');
            if (back) back.focus();
          }
        },
        { signal: signal }
      );

      btn.addEventListener(
        'keydown',
        function (e) {
          var next = null;
          if (e.key === 'ArrowDown') next = buttons[(i + 1) % buttons.length];
          else if (e.key === 'ArrowUp') next = buttons[(i - 1 + buttons.length) % buttons.length];
          else if (e.key === 'Home') next = buttons[0];
          else if (e.key === 'End') next = buttons[buttons.length - 1];
          if (next) {
            e.preventDefault();
            next.focus();
          }
        },
        { signal: signal }
      );

      if (mode === 'desktop') {
        /* Hover switches only after the pointer rests, so a diagonal move from a
           department to its products does not flick through the others */
        btn.addEventListener(
          'pointerenter',
          function (e) {
            if (e.pointerType !== 'mouse') return;
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function () {
              select(btn.getAttribute('data-bd-dept-btn'));
            }, HOVER_DELAY);
          },
          { signal: signal }
        );
        btn.addEventListener(
          'pointerleave',
          function () {
            clearTimeout(hoverTimer);
          },
          { signal: signal }
        );
      }
    });

    qsa(root, '[data-bd-mm-back]').forEach(function (back) {
      back.addEventListener(
        'click',
        function () {
          var was = current;
          showList();
          var btn = was ? buttonFor(was) : null;
          if (btn) btn.focus();
        },
        { signal: signal }
      );
    });

    return {
      select: select,
      showList: showList,
      current: function () {
        return current;
      },
      cancelHover: function () {
        clearTimeout(hoverTimer);
      }
    };
  }

  function initHeader(root) {
    if (!root || root.dataset.bdHeaderReady === '1') return;
    root.dataset.bdHeaderReady = '1';

    var ctrl = new AbortController();
    var signal = ctrl.signal;
    root._bdAbort = ctrl;

    var mq = window.matchMedia(DESKTOP_MQ);

    /* ——— Drawer: rendered after the header in this section, then hosted on
       <body> so the sticky header's stacking context can't trap the overlay ——— */
    var scope = root.closest('.shopify-section') || root.parentNode;
    var drawer = (scope && qs(scope, '[data-bd-drawer]')) || document.querySelector('body > [data-bd-drawer]');
    if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);

    function setScrolled() {
      root.classList.toggle('is-scrolled', window.scrollY > 2);
    }
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true, signal: signal });

    /* ——— Mega menu ——— */
    var mega = qs(root, '[data-bd-mega]');
    /* Only "Shop all products" opens it; the department shortcuts are plain links */
    var toggles = qsa(root, '.bd-shopall[data-bd-mega-toggle]');
    var opener = null;
    var megaMenu = null;

    if (mega) {
      mega.hidden = true;
      var megaRoot = qs(mega, '[data-bd-mm]');
      if (megaRoot) {
        megaMenu = DeptMenu(megaRoot, 'desktop', signal);
        megaMenu.select('cubicles');
      }
    }

    function sizeMega() {
      if (!mega || mega.hidden) return;
      var top = mega.getBoundingClientRect().top;
      var max = Math.max(260, window.innerHeight - top - 12);
      mega.style.setProperty('--bd-mega-max', max + 'px');
    }

    function isMegaOpen() {
      return !!mega && !mega.hidden;
    }

    function openMega(key, btn) {
      if (!mega) return;
      closeHelp(false);
      if (megaMenu) megaMenu.select(key || 'cubicles');
      mega.hidden = false;
      opener = btn || null;
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', t === opener ? 'true' : 'false');
      });
      sizeMega();
    }

    function closeMega(returnFocus) {
      if (!isMegaOpen()) return;
      if (megaMenu) megaMenu.cancelHover();
      mega.hidden = true;
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      if (returnFocus && opener) opener.focus();
      opener = null;
    }

    toggles.forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          var key = btn.getAttribute('data-bd-dept') || 'cubicles';
          if (isMegaOpen() && opener === btn) {
            closeMega(false);
            return;
          }
          openMega(key, btn);
          /* Opened from the keyboard: the panel sits after the nav in the page,
             so take focus to the chosen department (Escape brings it back) */
          if (e.detail === 0 && megaMenu) {
            var active = qs(mega, '[data-bd-dept-btn][aria-expanded="true"]');
            if (active) active.focus();
          }
        },
        { signal: signal }
      );
    });

    /* ——— Help & advice ——— */
    var helpBtn = qs(root, '[data-bd-help-toggle]');
    var helpPanel = qs(root, '[data-bd-help-panel]');
    if (helpPanel) helpPanel.hidden = true;

    function closeHelp(returnFocus) {
      if (!helpPanel || helpPanel.hidden) return;
      helpPanel.hidden = true;
      if (helpBtn) {
        helpBtn.setAttribute('aria-expanded', 'false');
        if (returnFocus) helpBtn.focus();
      }
    }

    if (helpBtn && helpPanel) {
      helpBtn.addEventListener(
        'click',
        function () {
          if (helpPanel.hidden) {
            closeMega(false);
            helpPanel.hidden = false;
            helpBtn.setAttribute('aria-expanded', 'true');
          } else {
            closeHelp(false);
          }
        },
        { signal: signal }
      );
    }

    /* Outside click closes; clicks inside the open menus do not */
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (isMegaOpen() && !mega.contains(t) && !toggles.some(function (b) { return b.contains(t); })) {
          closeMega(false);
        }
        if (helpPanel && !helpPanel.hidden && !helpPanel.contains(t) && !(helpBtn && helpBtn.contains(t))) {
          closeHelp(false);
        }
      },
      { signal: signal }
    );

    /* Keyboard: tabbing away from a menu closes it (pointer clicks on blank
       areas inside it do not, as they have no related target) */
    root.addEventListener(
      'focusout',
      function (e) {
        var to = e.relatedTarget;
        if (!to) return;
        if (isMegaOpen() && !mega.contains(to) && !toggles.some(function (b) { return b === to; })) {
          closeMega(false);
        }
        if (helpPanel && !helpPanel.hidden && !helpPanel.contains(to) && to !== helpBtn) {
          closeHelp(false);
        }
      },
      { signal: signal }
    );

    window.addEventListener(
      'resize',
      function () {
        if (mq.matches) sizeMega();
      },
      { passive: true, signal: signal }
    );
    window.addEventListener(
      'scroll',
      function () {
        if (isMegaOpen()) sizeMega();
      },
      { passive: true, signal: signal }
    );

    /* ——— Cart button opens the cart drawer where the theme has one ——— */
    function openCartDrawer(trigger) {
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl && typeof drawerEl.open === 'function') {
        drawerEl.open(trigger || null);
        return true;
      }
      if (window.BW && typeof window.BW.openCartDrawer === 'function') {
        window.BW.openCartDrawer();
        return true;
      }
      return false;
    }

    qsa(root, '#cart-icon-bubble, #cart-icon-bubble-mobile').forEach(function (cartLink) {
      cartLink.addEventListener(
        'click',
        function (e) {
          if (openCartDrawer(cartLink)) e.preventDefault();
        },
        { signal: signal }
      );
    });

    /* ——— Drawer (phone and tablet) ——— */
    var drawerOpener = null;
    var drawerMenu = null;

    function lockBody(on) {
      document.documentElement.classList.toggle('bd-nav-lock', !!on);
      document.body.classList.toggle('bd-nav-lock', !!on);
    }

    function isDrawerOpen() {
      return !!drawer && drawer.classList.contains('is-open');
    }

    function setDrawerOpeners(open) {
      qsa(root, '[data-bd-drawer-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function openDrawer(btn) {
      if (!drawer || mq.matches) return;
      drawerOpener = btn || null;
      if (drawerMenu) drawerMenu.showList();
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      lockBody(true);
      setDrawerOpeners(true);
      var body = qs(drawer, '[data-bd-drawer-body]');
      if (body) body.scrollTop = 0;
      var closeBtn = qs(drawer, 'button.bd-drawer__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer(returnFocus) {
      if (!drawer || !isDrawerOpen()) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockBody(false);
      setDrawerOpeners(false);
      if (drawerMenu) drawerMenu.showList();
      if (returnFocus && drawerOpener && drawerOpener.offsetParent !== null) drawerOpener.focus();
      drawerOpener = null;
    }

    qsa(root, '[data-bd-drawer-open]').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          openDrawer(btn);
        },
        { signal: signal }
      );
    });

    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      var drawerBody = qs(drawer, '[data-bd-drawer-body]');
      var homeParts = qsa(drawer, '[data-bd-drawer-home]');
      var drawerRoot = qs(drawer, '[data-bd-mm]');
      var drawerTitle = qs(drawer, '.bd-drawer__title');

      if (drawerRoot) {
        drawerMenu = DeptMenu(drawerRoot, 'drawer', signal, function (key) {
          homeParts.forEach(function (el) {
            el.hidden = !!key;
          });
          if (drawerBody) drawerBody.scrollTop = 0;
          if (drawerTitle) drawerTitle.classList.toggle('is-back', !!key);
        });
        drawerMenu.showList();

        /* Inside a department people tap the "Menu" title to get back to the list, so it does
           what the panel's Back button does (that button stays the control for keyboards). */
        if (drawerTitle) {
          drawerTitle.addEventListener(
            'click',
            function () {
              var key = drawerMenu.current();
              var back = key ? qs(drawerRoot, '[data-bd-dept-panel="' + key + '"] [data-bd-mm-back]') : null;
              if (back) back.click();
            },
            { signal: signal }
          );
        }
      }

      qsa(drawer, '[data-bd-drawer-close]').forEach(function (el) {
        el.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            closeDrawer(true);
          },
          { signal: signal }
        );
      });

      /* The drawer is modal: keep Tab inside it while open */
      drawer.addEventListener(
        'keydown',
        function (e) {
          if (e.key !== 'Tab' || !isDrawerOpen()) return;
          var panel = qs(drawer, '.bd-drawer__panel');
          var items = focusables(panel);
          if (!items.length) return;
          var first = items[0];
          var last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        },
        { signal: signal }
      );
    }

    /* ——— Escape closes whatever is open, innermost first ——— */
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        var active = document.activeElement;
        var inSearch = active && active.closest && active.closest('predictive-search[open]');
        if (inSearch) {
          if (typeof inSearch.close === 'function') inSearch.close();
          return;
        }
        if (helpPanel && !helpPanel.hidden) {
          closeHelp(true);
          return;
        }
        if (isMegaOpen()) {
          closeMega(true);
          return;
        }
        if (isDrawerOpen()) {
          if (drawerMenu && drawerMenu.current()) {
            var btn = qs(drawer, '[data-bd-dept-btn="' + drawerMenu.current() + '"]');
            drawerMenu.showList();
            if (btn) btn.focus();
          } else {
            closeDrawer(true);
          }
        }
      },
      { signal: signal }
    );

    function onBreakpoint() {
      if (mq.matches) closeDrawer(false);
      else {
        closeMega(false);
        closeHelp(false);
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);
    signal.addEventListener('abort', function () {
      if (mq.removeEventListener) mq.removeEventListener('change', onBreakpoint);
      else if (mq.removeListener) mq.removeListener(onBreakpoint);
      lockBody(false);
    });

    root._bdDrawer = drawer;
    document.documentElement.classList.add('bd-js');
  }

  function syncMobileCartBadge() {
    var desktop = document.getElementById('cart-icon-bubble');
    var mobile = document.getElementById('cart-icon-bubble-mobile');
    if (!desktop || !mobile) return;
    var src = desktop.querySelector('.bd-cart-badge, .cart-count-bubble');
    var dest = mobile.querySelector('.bd-cart-badge');
    if (src) {
      if (!dest) {
        dest = document.createElement('span');
        dest.className = 'bd-cart-badge';
        dest.setAttribute('aria-hidden', 'true');
        mobile.appendChild(dest);
      }
      dest.textContent = (src.textContent || '').trim();
      dest.style.display = '';
    } else if (dest) {
      dest.remove();
    }
  }

  var badgeObserver = null;
  function watchCartBadge() {
    if (badgeObserver) badgeObserver.disconnect();
    syncMobileCartBadge();
    var cartEl = document.getElementById('cart-icon-bubble');
    if (cartEl && window.MutationObserver) {
      badgeObserver = new MutationObserver(syncMobileCartBadge);
      badgeObserver.observe(cartEl, { childList: true, subtree: true, characterData: true });
    }
  }

  function boot() {
    qsa(document, '[data-bd-header]').forEach(initHeader);
    watchCartBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: tear down before a section reload so listeners never double up,
     and drop the drawer this section moved onto <body> */
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-bd-header]') : null;
    if (!el) return;
    if (el._bdAbort) el._bdAbort.abort();
    if (el._bdDrawer && el._bdDrawer.parentElement === document.body) el._bdDrawer.remove();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-bd-header]') : null;
    if (!el) return;
    /* A stale drawer from the previous render of this section */
    var sid = e.detail && e.detail.sectionId;
    qsa(document.body, ':scope > [data-bd-drawer]').forEach(function (d) {
      if (sid && d.getAttribute('data-bd-section') === sid) d.remove();
    });
    el.dataset.bdHeaderReady = '';
    initHeader(el);
    watchCartBadge();
  });
})();
